import { render, staticRenderFns } from "./achievementList.vue?vue&type=template&id=53e5c890&scoped=true&"
import script from "./achievementList.vue?vue&type=script&lang=js&"
export * from "./achievementList.vue?vue&type=script&lang=js&"
import style0 from "./achievementList.vue?vue&type=style&index=0&id=53e5c890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5c890",
  null
  
)

export default component.exports